import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import RecoilRootWrapper from "./recoil/RecoilRoot";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <RecoilRootWrapper>
    <App />
  </RecoilRootWrapper>
);

reportWebVitals();
